import { clientBase } from "../common";

export const getItems = (_categoryId, _perPage, _currentPage) => {
  return clientBase(
    `v2/courses/${
      process.env.VUE_APP_PROYECT_ID
    }/${_categoryId}/${_perPage}?page=${_currentPage}`,
    "GET"
  );
};
